
const digest = 'c360f2dde4144bf45e81f09bcba2974bf8951950a316630dbbf37c189f192dea';
const classes = {"wrapper":"_wrapper_hjihu_1","date":"_date_hjihu_14","file":"_file_hjihu_18","name":"_name_hjihu_24","savedBy":"_savedBy_hjihu_30","itemControls":"_itemControls_hjihu_38","link":"_link_hjihu_44"};
const css = `._wrapper_hjihu_1 {
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 24px 19px;
  gap: 28px;
  border: 1px solid #eaedf3;
  border-top: 0;
  background: #ffffff;
}
._wrapper_hjihu_1:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_hjihu_1 ._date_hjihu_14 {
  font-size: 14px;
  color: #000000;
}
._wrapper_hjihu_1 ._file_hjihu_18 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 6px;
}
._wrapper_hjihu_1 ._file_hjihu_18 ._name_hjihu_24 {
  font-weight: 500;
  font-size: 14px;
  color: #1665d8;
  text-decoration: underline;
}
._wrapper_hjihu_1 ._file_hjihu_18 ._savedBy_hjihu_30 {
  font-size: 12px;
  color: #9ea0a5;
}
._wrapper_hjihu_1 ._file_hjihu_18 ._savedBy_hjihu_30 span {
  color: #000;
  font-weight: 500;
}
._wrapper_hjihu_1 ._itemControls_hjihu_38 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
}
._wrapper_hjihu_1 ._itemControls_hjihu_38 ._link_hjihu_44 {
  font-weight: 500;
  font-size: 14px;
  color: #1665d8;
  text-decoration: underline;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  